import * as storage from '../../utils/storage';
import Button from '../../components/Button/Button';
import { BLACK, GRAY_BACKGROUND, NEUTRAL_TEXT10 } from '../../config/designSystem/Colors';
import { H3, ParagraphLRegular } from '../../config/designSystem/typography';
import { RESEND_CODE } from '../../state/mutations/User';
import { SMALL_HORIZONTAL_MARGIN_FN } from '../../config/designSystem/Layout';
import {  View } from 'react-native';
import { logAmplitude } from '../../utils/analytics/analytics';
import { useAvailableDimensions } from '../ui/useAvailableDimensions';
import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useStores } from '../useStores';

type ModalAlertProps = {
    logout: () => void;
    manageLogin: () => Promise<void>;
}

export const useModalEndOfTrial = ({logout, manageLogin} : ModalAlertProps) => {
  const rootStore = useStores();
  const labels = rootStore?.language?.translate?.MOBILE?.ROOT;
  const [resentCodeAvailable, setResentButtonAvailable] = useState(true);
  const {width} = useAvailableDimensions();



  useEffect(() => {
    const giveOptionToResent = async () => {
      const lastResent = await storage.loadString('date_resend') as string;
      const dateLastResent = (new Date(lastResent)).getTime();
      if (dateLastResent + 3600 * 24 * 1000 > new Date().getTime()) {
        setResentButtonAvailable(false);
      }
    };
    giveOptionToResent();


  }, []);

  const [resendCodeMutation] = useMutation(
    RESEND_CODE, {
      fetchPolicy: 'no-cache'
    }
  );

  const buttons = [
    {
      text: labels?.MODAL_TRIAL.LOGOUT ? labels?.MODAL_TRIAL.LOGOUT : 'Just log me out',
      onPress: () => {
        logAmplitude('Alert End Of Trial Logout Button Pressed');
        logout();
      },
    },
    {
      text: labels?.MODAL_TRIAL.I_JUST_DID ? labels?.MODAL_TRIAL.I_JUST_DID : 'I just did',
      onPress: () => {
        logAmplitude('Alert End Of Trial I-Just-Did Button Pressed');
        manageLogin();
      }
    }];

  if (resentCodeAvailable && !!rootStore?.user?.user?.email) {
    buttons.splice(1, 0, {
      text: labels?.MODAL_TRIAL.RESEND_CODE ? labels?.MODAL_TRIAL.RESEND_CODE : 'Resent Code',
      onPress: () => {
        logAmplitude('Alert End Of Trial Resend Code Button Pressed');
        setResentButtonAvailable(false);
        storage.saveString('date_resend', (new Date()).toString());
        resendCodeMutation({ variables: { email: rootStore?.user?.user?.email } });
      },
    });
  }
  const ROW_GAP = 20;
  const NB_BUTTONS = buttons.length;
  const WIDTH_BUTTON = (width - NB_BUTTONS*ROW_GAP)/NB_BUTTONS;
  const modal =  () => {

    return(
      <View style={{
        alignItems: 'center', justifyContent: 'center', flex: 1
      }}>
        <View
          style={{
            borderRadius: 20,
            justifyContent: 'space-between',
            alignItems: 'center',
            borderWidth: 1,
            backgroundColor: GRAY_BACKGROUND,

          }}>
          <View style={{ marginVertical: 40, marginHorizontal: 20 }}>
            <View style={{ marginBottom: 20 }}>
              <H3 color={BLACK}>
                {
                  labels?.MODAL_TRIAL.TITLE ? labels?.MODAL_TRIAL.TITLE : 'End of your trial.'}
              </H3>
            </View>
            <ParagraphLRegular color={BLACK}>
              {
                labels?.MODAL_TRIAL.MAIN ? labels?.MODAL_TRIAL.MAIN : 'Your must validate your email now'
              }
            </ParagraphLRegular>
          </View>
          <View style={{ flexDirection: 'row', rowGap:ROW_GAP, marginBottom: 20  }}>
            {buttons.map((button, idx) => {
              return (
                <Button
                  onPress={button.onPress}
                  color={NEUTRAL_TEXT10}
                  key={idx}
                  paddingVertical={15}
                  paddingHorizontal={SMALL_HORIZONTAL_MARGIN_FN(width)}
                  label={button.text}
                  marginHorizontal={SMALL_HORIZONTAL_MARGIN_FN(width)}
                  width={WIDTH_BUTTON}
                  smallText={true}
                />
              );
            })}
          </View>
        </View>
      </View>
    );};
  return {modal};
};